import React from 'react';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { BonoCardBackground } from '../../../../shared/ui/bono-card-backgound';
import { HuchaCol, HuchaWrapper } from '../../../../shared/ui/layout-composition';
import { HuchaRenovadoresCardC1 } from './hucha-renovadores-card-c1';
import { HuchaRenovadoresCardC2 } from './hucha-renovadores-card-c2';
import { HuchaRenovadoresCardC3 } from './hucha-renovadores-card-c3';

export const HuchaRenovadoresCard = ({
	huchaValues,
	bonoPosventaExists,
}: {
	huchaValues: HuchaVentaValues;
	bonoPosventaExists: boolean;
}) => {
	return (
		<BonoCardBackground stretchContent data-testid="hucha-venta-card-container" wrap={'never'}>
			<HuchaWrapper $bonoPosventaExists={bonoPosventaExists}>
				<HuchaCol $bonoPosventaExists={bonoPosventaExists}>
					<HuchaRenovadoresCardC1 huchaValues={huchaValues} />
					<HuchaRenovadoresCardC2 dineroHucha={huchaValues?.dineroHucha || '0'} />
				</HuchaCol>
				<HuchaRenovadoresCardC3 huchaValues={huchaValues} />
			</HuchaWrapper>
		</BonoCardBackground>
	);
};
